module.exports = __webpack_public_path__ + "static/img/icon1-10.169b9b1b.png";